export { MarkAppMounted, isAppMounted } from './mark-app-mounted';
